import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { AttestCommandHandler } from './attest-command-handler.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { InvoicePdfCommandHandler } from './invoice-pdf-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { RegisterPaymentCommandHandler } from './register-payment-command-handler.service';
import { SendCommandHandler } from './send-command-handler.service';
import { DeleteInvoicesCommandHandler } from './delete-invoices-command-handler.service';
import { CreditInvoiceCommandHandler } from './credit-invoice-command-handler.service';
import { InvoiceExportCommandHandler } from './export-invoices-command-handler.service';
import { ReminderInvoiceCommandHandler } from './reminder-invoice-command-handler.service';
import { SetDefermentDateCommandHandler } from './set-deferment-date-command-handler.service';
import { DebtCollectionCommandHandler } from './debt-collection-command-handler.service';
import { RegulateFromBalanceCommandHandler } from './regulate-from-balance-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { CustomerLossCommandHandler } from './customer-loss-command-handler.service';
import { CreditInvoicesCommandHandler } from './credit-invoices-command-handler.service';
import { InvoicePdfWithRegulationsCommandHandler } from './invoice-pdf-with-regulations-command-handler.service';
import { InvoiceExportWithInvoiceRowsCommandHandler as InvoiceExportWithInvoiceRowsCommandHandler } from './export-invoices-with-invoice-rows-command-handler.service';

@Injectable()
export class UnpaidInvoiceCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    attestHandler: AttestCommandHandler,
    createInvoiceReminderHandler: ReminderInvoiceCommandHandler,
    debtCollectionHandler: DebtCollectionCommandHandler,
    creditHandler: CreditInvoiceCommandHandler,
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    deleteManyHandler: DeleteInvoicesCommandHandler,
    creditManyHandler: CreditInvoicesCommandHandler,
    invoicesExportHandler: InvoiceExportCommandHandler,
    pdfHandler: InvoicePdfCommandHandler,
    pdfWithRegulationsHandler: InvoicePdfWithRegulationsCommandHandler,
    registerPaymentHandler: RegisterPaymentCommandHandler,
    regulateFromBalanceHandler: RegulateFromBalanceCommandHandler,
    sendHandler: SendCommandHandler,
    setDefermentDateHandler: SetDefermentDateCommandHandler,
    customerLossHandler: CustomerLossCommandHandler,
    invoicesExportWithInvoiceRowsHandler: InvoiceExportWithInvoiceRowsCommandHandler
  ) {
    super();
    this.addHandler(invoiceCommand.attest, attestHandler);
    this.addHandler(invoiceCommand.getpdf, pdfHandler);
    this.addHandler(invoiceCommand.getpdfWithRegulations, pdfWithRegulationsHandler);
    this.addHandler(invoiceCommand.credit, creditHandler);
    this.addHandler(invoiceCommand.customerLoss, customerLossHandler);
    this.addHandler(invoiceCommand.createReminder, createInvoiceReminderHandler);
    this.addHandler(invoiceCommand.debtCollection, debtCollectionHandler);
    this.addHandler(invoiceCommand.export, invoicesExportHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(invoiceCommand.registerPayment, registerPaymentHandler);
    this.addHandler(invoiceCommand.regulateFromBalance, regulateFromBalanceHandler);
    this.addHandler(invoiceCommand.send, sendHandler);
    this.addHandler(invoiceCommand.deleteMany, deleteManyHandler);
    this.addHandler(invoiceCommand.setDefermentDate, setDefermentDateHandler);
    this.addHandler(invoiceCommand.creditAll, creditManyHandler);
    this.addHandler(invoiceCommand.exportWithInvoiceRows, invoicesExportWithInvoiceRowsHandler);
  }
}
